import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { RatioOptions } from '@df/ui/atomic/atomic-options';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { CmsHeroBannerComponent, NCmsHeroBanner } from '../hero-banner/cms-hero-banner.component';

let uid = 0;

export const carouselUid = () => {
    return uid++;
};

export namespace NHeroCarouselComponent {
    export interface IContent {
        slides: NCmsHeroBanner.IComponentData[];
        autoplay?: boolean;
        interval?: number;
        loop?: boolean;
        showArrows?: boolean;
        ratio?: string;
    }
}

@Component({
    selector: 'cms-hero-banner-carousel',
    templateUrl: './cms-hero-banner-carousel.html',
    styleUrls: ['./cms-hero-banner-carousel.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsHeroCarouselComponent>({
    id: 'hero-banner-carousel',
    name: 'Hero Banner Carousel',
    description: 'Carousel with slides',
    tags: ['banner', 'image', 'carousel'],
    fields: [
        // general
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        {
            key: 'autoplay',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Autoplay',
            default: false,
            canShow: (data: NHeroCarouselComponent.IContent) => !!(data?.slides.length > 1)
        },
        {
            key: 'interval',
            type: NICmsContentField.EFieldType.number,
            title: 'Interval',
            canShow: (data: NHeroCarouselComponent.IContent) => !!(data?.autoplay && data?.slides.length > 1),
            default: 5000
        },
        {
            key: 'loop',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Loop',
            default: false,
            canShow: (data: NHeroCarouselComponent.IContent) => !!(data?.slides.length > 1)
        },
        {
            key: 'showArrows',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Show Navigate Arrows',
            default: true,
            canShow: (data: NHeroCarouselComponent.IContent) => data?.slides.length > 1
        },
        <NICmsContentField.IChoiceField>{
            key: 'ratio',
            type: NICmsContentField.EFieldType.choice,
            title: 'Ratio',
            options: RatioOptions,
            description: 'Proportions width x height',
            default: ''
        },
        // slides
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'slides',
            title: 'Slides',
            itemName: 'Slide',
            required: true,
            fields: NCmsHeroBanner.getFields(),
            defaultSize: 2
        },
        NICmsContentComponent.backgroundField
    ]
})
export class CmsHeroCarouselComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NHeroCarouselComponent.IContent;

    readonly uid = `page-carousel-component-${carouselUid()}`;
}
